import { Injectable } from '@angular/core';
import { DbRecord } from './db-record'
import { ArcService } from './arc.service'
import { UtilsService } from './utils.service'
import { Note } from './note'
import { RuntimeService } from './runtime.service'
import { Project } from './project'
import { ProjectService } from './project.service'
import { Observable }  from 'rxjs/Observable';

@Injectable()
export class NoteService {
  editModeNote: Note


  constructor(
    private arcs: ArcService,
    private utils: UtilsService,
    private rs: RuntimeService,
    private projects: ProjectService
  ) {
    this.projects.ns = this
  }

  newFromSaved(p: Project, params: Object) {
    Object.keys(params).forEach((k) => {
      let obj = params[k]
      this.createNote({
        id: k,
        parentId: obj['parentId'],
        project: p,
        text: obj['text'],
        date: new Date(obj['date']),
        creator: obj['creator']
      })
    })
  }


  createNote(obj: Object) {
    return new Note(obj['id'],
      obj['parentId'],
      obj['project'],
      obj['text'],
      obj['date'],
      obj['creator'] || this.utils.email
    )
  }

  newNote(itm: DbRecord) {
    return this.createNote({
      id: this.utils.uniqueIdentifier,
      parentId: itm.id,
      project: this.rs.currentProject,
      text: '',
      date: new Date()
    })
  }

  save(note: Note): Observable<any> {
    let obs = this.arcs.run(note.saveParams)
    obs.subscribe((x) => x)
    return obs
  }

  delete(note: Note): Observable<any> {
    let obs = this.arcs.run(note.deleteParams)
    obs.subscribe((x) => {
      if (x['isSuccess'])
        note.project.notesMap.get(note.parentId).delete(note.creator)
    })
    return obs
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/note.service.ts